import { useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { KB_SUPPORT, SUPPORT } from '../../constants/support';
import { C } from '../../theme/palette';

export function SupportPage({ onNav, soc, estMixte, univers, setUnivers }) {
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState('');
  const ql = (q || '').trim().toLowerCase();
  // Au magasin, les sujets du seul chantier (créer un chantier, sa
  // rentabilité, le pointage sur chantier) n'ont rien à y faire.
  const mag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  const sujets = mag
    ? KB_SUPPORT.filter((e) => !(e[2].includes('chantier') && !e[2].includes('magasin')))
    : KB_SUPPORT;
  const results = ql
    ? sujets.filter((e) => (e[0] + ' ' + e[1] + ' ' + e[2]).toLowerCase().includes(ql))
    : sujets;
  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="💬 Support & aide"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <Card style={{ marginBottom: 12 }}>
        <Bar icon="📞" title="Nous contacter" color={C.navy} />
        <div
          style={{
            padding: 13,
            display: 'grid',
            gridTemplateColumns: SUPPORT.telephone ? '1fr 1fr' : '1fr',
            gap: 8,
          }}
        >
          <a href={'mailto:' + SUPPORT.email} style={{ textDecoration: 'none' }}>
            <div
              style={{
                background: C.navy,
                color: '#fff',
                borderRadius: 9,
                padding: '11px',
                textAlign: 'center',
                fontSize: 10,
                fontWeight: 700,
              }}
            >
              ✉ {SUPPORT.email}
            </div>
          </a>
          {SUPPORT.telephone && (
            <a
              href={'tel:' + SUPPORT.telephone.replace(/\s/g, '')}
              style={{ textDecoration: 'none' }}
            >
              <div
                style={{
                  background: C.green,
                  color: '#fff',
                  borderRadius: 9,
                  padding: '11px',
                  textAlign: 'center',
                  fontSize: 10,
                  fontWeight: 700,
                }}
              >
                📞 Appeler
              </div>
            </a>
          )}
        </div>
      </Card>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="🔎 Pose ta question (ex. ajouter un article, TVA, remise, salaire, chantier…)"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          border: '2px solid ' + C.navy,
          borderRadius: 12,
          padding: '13px 14px',
          fontSize: 12,
          marginBottom: 10,
        }}
      />
      <div style={{ fontSize: 9, fontWeight: 700, color: C.muted, marginBottom: 8 }}>
        {ql
          ? results.length +
            ' réponse' +
            (results.length > 1 ? 's' : '') +
            ' trouvée' +
            (results.length > 1 ? 's' : '')
          : "Toute l'aide — " + sujets.length + ' sujets. Tape un mot pour chercher.'}
      </div>
      {results.map((e, i) => (
        <Card key={i} style={{ marginBottom: 7 }}>
          <div
            onClick={() => setOpen(open === e[0] ? null : e[0])}
            style={{
              padding: '12px 14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <span style={{ fontSize: 10.5, fontWeight: 700, flex: 1, marginRight: 8 }}>{e[0]}</span>
            <span
              style={{
                color: C.muted,
                transform: open === e[0] ? 'rotate(90deg)' : 'none',
                transition: 'transform .15s',
              }}
            >
              ›
            </span>
          </div>
          {open === e[0] && (
            <div style={{ padding: '0 14px 13px', fontSize: 9.5, color: C.grey, lineHeight: 1.65 }}>
              {e[1]}
            </div>
          )}
        </Card>
      ))}
      {ql && results.length === 0 && (
        <div
          style={{
            textAlign: 'center',
            fontSize: 10,
            color: C.muted,
            padding: '20px 10px',
            lineHeight: 1.7,
          }}
        >
          Aucune réponse pour « {q} ».
          <br />
          Essaie d'autres mots, ou contacte-nous (Email / Appeler ci-dessus).
        </div>
      )}
      <div style={{ textAlign: 'center', fontSize: 8, color: C.muted, marginTop: 16 }}>
        Aide complète — {sujets.length} sujets, tous les modules · 🇨🇭
      </div>
    </Shell>
  );
}
